export enum CapitalProviderTypes {
  cfdi = 'CFDI',
  bank = 'BANK',
  familyOffice = 'FAMILY_OFFICE',
  marketplace = 'MARKETPLACE',
  multiStratgy = 'MULTI_STRATEGY',
  nonProfit = 'NON_PROFIT',
  privateCredit = 'PRIVATE_CREDIT',
  privateEquity = 'PRIVATE_EQUITY',
  specialtyFinance = 'SPECIALTY_FINANCE',
}
